import { NavLink, useLocation } from 'react-router-dom';
import { IoHomeOutline, IoBookOutline, IoStatsChartOutline, IoPeopleOutline, IoMenuOutline } from 'react-icons/io5';

export default function MobileNavigation({ onMenuClick, menuOpen }) {
  const { pathname } = useLocation();
  const items = [
    { to: '/', label: 'Home', Icon: IoHomeOutline },
    { to: '/reading', label: 'Read', Icon: IoBookOutline },
    { to: '/progress', label: 'Progress', Icon: IoStatsChartOutline },
    { to: '/family', label: 'Family', Icon: IoPeopleOutline },
  ];
  return <nav className="mobile-navigation" aria-label="Main tabs">
    {items.map(({ to, label, Icon: _Icon }) => <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `mobile-tab ${isActive ? 'mobile-tab--active' : ''}`}>
      <_Icon size={23} aria-hidden="true" /><span>{label}</span>
    </NavLink>)}
    <button className={`mobile-tab ${!items.some(item => item.to === pathname) ? 'mobile-tab--active' : ''}`} onClick={onMenuClick} aria-label="Open more navigation" aria-expanded={menuOpen} aria-controls="app-navigation">
      <IoMenuOutline size={23} aria-hidden="true" /><span>More</span>
    </button>
  </nav>;
}
